import React, { useEffect, useState } from "react";
import { useTable, useSortBy, usePagination } from "react-table";
import { PrevBtn, NextBtn, PaginationWrapper } from "../Styles/PageStyles";
import Images from "../../Images";
import tw from "tailwind-styled-components";
import moment from "moment";
import Config, { PaginationLimit } from "../../Config";
import { MdModeEdit } from "react-icons/md";
import { IoMdEye } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import { IoMdMore } from "react-icons/io";

const Table = ({
    ApiData,
    setSelectedData,
    setEditAsset,
    setUploadLogo,
    setViewDetail,
    userType,
    setAddCharges,
    setEditBasicAsset,
    setEditPurchaseDetails,
    setEditAssignmentDetails,
    setEditMaintenanceDetails,
    setEditDocuments,
    setViewMaintenanceDetail,
    setViewDocuments,
    setViewTesting
}) => {
    const [data, setData] = useState([
        {
            deviceName: "",
            extractionTime: "",
            processingTime: "",
            drops: "",
            action: "",
        },
    ]);
    const navigate = useNavigate();
    const [selectedRow, setSelectedRow] = useState(null);
    const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);
    const [previousId, setPreviousId] = useState(null);
    const [currentPage, setCurrentPage] = useState(0);
    const [openActionMenu, setOpenActionMenu] = useState(null);
    const toggleRow = (index) => {
        setSelectedRow(selectedRow === index ? null : index);
    };

    const edit = (item) => {
        setEditAsset(true);
        setSelectedData(item);
        setOpenActionMenu(null);
    };
    const editbasic = (item) => {
        setEditBasicAsset(true);
        setSelectedData(item);
        setOpenActionMenu(null);
    };
    const editpurchase = (item) => {
        setEditPurchaseDetails(true);
        setSelectedData(item);
        setOpenActionMenu(null);
    };
    const editAssignment = (item) => {
        setEditAssignmentDetails(true);
        setSelectedData(item);
        setOpenActionMenu(null);
    };
    const editMaintenance = (item) => {
        setEditMaintenanceDetails(true);
        setSelectedData(item);
        setOpenActionMenu(null);
    };
    const editDocuments = (item) => {
        setEditDocuments(true);
        setSelectedData(item);
        setOpenActionMenu(null);
    };

    const viewDetail = (item) => {
        setViewDetail(true);
        setSelectedData(item);
        setOpenActionMenu(null);
    };
    const viewMaintenanceDetails = (item)=>{
        setViewMaintenanceDetail(true);
        setSelectedData(item);
        setOpenActionMenu(null);
        

    }
    const viewDocuments = (item) => {
        setViewDocuments(true);
        setSelectedData(item);
        setOpenActionMenu(null);
    };
    const viewTesting = (item) => {
        setViewTesting(true);
        setSelectedData(item);
        setOpenActionMenu(null);
    };

    const ActionBtns = (item) => {
        const openMenu = (id) => {
            setPreviousId(openActionMenu);
            setOpenActionMenu((prevId) => {
                return prevId === id ? null : id;
            });
        };

        return (
            <ActionBtnWrapper>
                {openActionMenu === item.id && (
                    <MenuOptions id="menuOptions">
                        {/* <MenuItem title="Edit Documents" onClick={() => editDocuments(item)}>
                            <MdModeEdit className="text-gray-700 mr-2" />
                            Edit Document Details
                        </MenuItem> */}

                        <MenuItem title="View Detail" onClick={() => viewDetail(item)}>
                            <IoMdEye className="text-gray-700 mr-2" /> View Detail
                        </MenuItem>
                        <MenuItem title="View Maintenance Detail" onClick={() => viewMaintenanceDetails(item)}>
                            <IoMdEye className="text-gray-700 mr-2" /> View Maintenance Detail
                        </MenuItem>
                        <MenuItem title="View Document" onClick={() => viewDocuments(item)}>
                            <IoMdEye className="text-gray-700 mr-2" /> View Documents Detail
                        </MenuItem>
                        <MenuItem title="View Document" onClick={() => viewTesting(item)}>
                            <IoMdEye className="text-gray-700 mr-2" /> For Testing Only
                        </MenuItem>

                    </MenuOptions>
                )}
                <Btn title="Actions" type="button" onClick={() => openMenu(item.id)}>
                    <IoMdMore className="text-gray-600" size={24} />
                </Btn>
            </ActionBtnWrapper>
        );
    };

    useEffect(() => {
        if (ApiData) {
            const tempData = ApiData.map((item) => ({
                getId: getId(item),
                assetName: getName(item),
                catogory: getCatogory(item),
                assignedProperty: getAssignedProperty(item),
                status: getStatus(item.status),
                lastdate: getLastDate(item),
                nextdate: getNextDate(item),
                action: ActionBtns(item),
               
            }));
            setData(tempData);
        }
    }, [ApiData, openActionMenu]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                !event.target.closest("#menuOptions") &&
                !event.target.closest(".action-btn")
            ) {
                setOpenActionMenu(null);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const getName = (item) => {
        return (
            <div className="flex flex-col gap-[2px]">
                {/* <p className="text-zinc-900 font-semibold">{item.name}</p> */}
                <p className="text-zinc-900 font-semibold">Sofa Set</p>
            </div>
        );
    };

    const getCatogory = (item) => {
        return (
            <div>
                <span>Electrical</span>
            </div>
        );
    };
    const getAssignedProperty = (item) => {
        return (
            <div className="flex gap-3">
                <div className="flex flex-col ">
                    <span>Building Entrance Star</span>
                </div>
            </div>
        );
    };
    const getId = (item) => {
        return (
            <>
                <span>A001</span>
            </>
        );
    };

    const getStatus = (status) => {
        if (status == 1) {
            return <Unverified>Unverified</Unverified>;
        } else if (status == 2) {
            return <Verified>Verified</Verified>;
        } else if (status == 3) {
            return <Active>Active</Active>;
        } else {
            return <Enrolled>In Use</Enrolled>;
        }
    };
    const getLastDate = (item) => {
        return (
            <div className="flex items-center gap-2">
                {/* {getDeviceIcon(item.device)} */}
                {moment(item.lastLogin).format("DD-MM-YYYY")}
            </div>
        );
    };
    const getNextDate = (item) => {
        return (
            <div className="flex items-center gap-2">
                {/* {getDeviceIcon(item.device)} */}
                {moment(item.lastLogin).format("DD-MM-YYYY")}
            </div>
        );
    };

    //   const getDeviceIcon = (device) => {
    //     switch (device) {
    //       case 1:
    //         return <DiAndroid className="text-gray-500 text-lg" />;
    //       case 2:
    //         return <FaApple className="text-gray-500 text-lg" />;
    //       case 3:
    //         return <FaWindows className="text-gray-500 text-lg" />;
    //       default:
    //         return <DiAndroid className="text-gray-500 text-lg" />;
    //     }
    //   };

    useEffect(() => {
        const handleResize = () => {
            setIsMobileView(window.innerWidth < 768);
        };
        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    const columns = React.useMemo(() => {
        if (isMobileView) {
            // Display only "User" column for mobile screens
            return [
                {
                    Header: "Asset Name",
                    accessor: "assetName",
                },
                {
                    Header: "Assigned Property",
                    accessor: "assignedProperty",
                },
            ];
        }

        // Columns for larger screens
        return [
            {
                Header: "Asset Id",
                accessor: "getId",
            },
            {
                Header: "Asset Name",
                accessor: "assetName",
            },
            {
                Header: "Catogory",
                accessor: "catogory",
            },
            {
                Header: "Assigned Property",
                accessor: "assignedProperty",
            },
            {
                Header: "Status",
                accessor: "status",
            },
            {
                Header: "Last Maintenance",
                accessor: "lastdate",
            },
            {
                Header: "Next Maintenance",
                accessor: "nextdate",
            },

            {
                Header: "Action",
                accessor: "action",
            },
        ];
    }, [isMobileView]);

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        prepareRow,
        pageOptions,
        page,
        state: { pageIndex, pageSize },
        previousPage,
        nextPage,
        setPageSize,
        canPreviousPage,
        canNextPage,
    } = useTable(
        {
            data,
            columns,
            initialState: { pageIndex: currentPage, pageSize: PaginationLimit },
        },
        useSortBy,
        usePagination
    );

    // useEffect(() => {
    //   setPageSize(PaginationLimit);
    // }, []);
    useEffect(() => {
        setCurrentPage(pageIndex); // Update current page on state change
    }, [pageIndex]);
    return (
        <>
            <CustomTable {...getTableProps()}>
                <Thead>
                    {headerGroups.map((headerGroup) => (
                        <Tr {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map((column) => (
                                <Th {...column.getHeaderProps(column.getSortByToggleProps())}>
                                    {column.render("Header")}
                                    <span>
                                        {column.isSorted ? (
                                            <img
                                                src={Images.Arrow}
                                                alt="down arrow"
                                                className={`${column.isSortedDesc ? "-rotate-90" : "rotate-90"
                                                    } w-1.5 inline-block ml-1.5`}
                                            />
                                        ) : (
                                            ""
                                        )}
                                    </span>
                                </Th>
                            ))}
                        </Tr>
                    ))}
                </Thead>
                <Tbody {...getTableBodyProps()} hasdata={(ApiData?.length > 0).toString()}>
                {/* <Tbody
                    {...getTableBodyProps()}
                    className={ApiData?.length > 0 ? "border-b" : ""}
                > */}
                    {page.map((row, rowIndex) => {
                        prepareRow(row);
                        return (
                            <React.Fragment key={rowIndex}>
                                <Tr {...row.getRowProps()} hasdata={(ApiData?.length > 0).toString()}>
                                {/* <Tr
                                    {...row.getRowProps()}
                                    className={ApiData?.length > 0 ? "border-b" : ""}
                                > */}
                                    {row.cells.map((cell, cellIndex) => {
                                        return (
                                            <Td
                                                {...cell.getCellProps()}
                                                onClick={() => {
                                                    if (
                                                        cellIndex === 0 ||
                                                        (cellIndex === 1 && window.innerWidth < 768)
                                                    ) {
                                                        toggleRow(rowIndex);
                                                    }
                                                }}
                                            >
                                                {cell.render("Cell")}
                                            </Td>
                                        );
                                    })}
                                </Tr>
                                {selectedRow === rowIndex && window.innerWidth < 768 && (
                                    <Tr>
                                        <Td colSpan={columns.length}>
                                            <ul className="flex flex-col gap-2">
                                                <li>
                                                    <strong>City:</strong> {data[rowIndex].city}
                                                </li>
                                                <li>
                                                    <strong>Created At:</strong> {data[rowIndex].date}
                                                </li>
                                                <li className="flex gap-2">
                                                    <strong>Status:</strong> {data[rowIndex].status}
                                                </li>
                                                <li>
                                                    <strong>Action:</strong> {data[rowIndex].action}
                                                </li>
                                            </ul>
                                        </Td>
                                    </Tr>
                                )}
                            </React.Fragment>
                        );
                    })}
                </Tbody>
            </CustomTable>
            {ApiData?.length > 0 && (
                <PaginationWrapper>
                    <div className="px-2">
                        Page{" "}
                        <em>
                            {pageIndex + 1} of {pageOptions.length}
                        </em>
                    </div>
                    <div className="flex gap-1">
                        <PrevBtn onClick={() => previousPage()} disabled={!canPreviousPage}>
                            <img src={Images.Arrow} alt="arrow" className="w-2 opacity-75 " />
                        </PrevBtn>
                        <NextBtn onClick={() => nextPage()} disabled={!canNextPage}>
                            <img
                                src={Images.Arrow}
                                alt="arrow"
                                className="w-2 rotate-180 opacity-75 "
                            />
                        </NextBtn>
                    </div>
                </PaginationWrapper>
            )}
        </>
    );
};
const Btn = tw.button`action-btn grid place-items-center border border-gray-300 w-8 h-8 rounded-full transform transition duration-200 hover:scale-110 hover:shadow-md`;
const ActionBtnWrapper = tw.div`flex items-center gap-3 relative`;
const CustomTable = tw.table` w-full text-zinc-600`;
const Thead = tw.thead`border-b uppercase text-zinc-500 bg-slate-100`;
// const Tbody = tw.tbody`${({ hasdata }) => (hasdata === "true" ? "border-b" : "")}`;

const Tbody = tw.tbody`${(props) => (props.hasdata ==="true" ? "border-b" : "")}`;
const Tr = tw.tr`${(props) =>
    props.hasdata === "true"
      ? "border-b"
      : ""} rounded-md overflow-hidden hover:bg-slate-50`;

// const Tr = tw.tr`${({ hasdata }) =>
//     hasdata === "true" ? "border-b" : ""} rounded-md overflow-hidden hover:bg-slate-50`;
const Th = tw.th`text-left text-sm md:p-3 p-0.5 font-medium text-gray-500`;
const Td = tw.td`p-3 text-sm md:p-3 text-left`;
const Active = tw.div`bg-green-100 text-green-700 text-xs border-green-300 border w-24 h-7 flex items-center justify-center rounded-full`;
const Verified = tw.div`bg-teal-100 text-teal-700 text-xs border-teal-300 border w-24 h-7 flex items-center justify-center rounded-full`;
const Unverified = tw.div`bg-rose-100 text-rose-700 text-xs border-rose-300 border w-24 h-7 flex items-center justify-center rounded-full`;
const Enrolled = tw.div`bg-yellow-100 text-yellow-700 text-xs border-yellow-300 border w-24 h-7 flex items-center justify-center rounded-full`;
const MenuOptions = tw.div`absolute bottom-10 right-0 py-4 w-max bg-white z-50 rounded-lg shadow-lg border border-gray-200 flex flex-col`;
const MenuItem = tw.div`flex items-center gap-2 px-4 py-2 text-base font-medium cursor-pointer hover:bg-gray-100`;
export default Table;
